<template>
<div class="journal-detail-list">
	<app-table
		:add-icon="isMobile"
		:name-tooltip="nameTooltip"
		detail-seat
		class="listjournal is-not-selectable no-main-list relative"
		:columns="columns"
		local-search
		:main-list="false"
		name="journal-detail"
		padding="px-0"
		:rows="rows"
		:created-add="createdAdd"
		:input-search="false"
		:t-foot="false"
		@add-icon="addIcon"
		@create-action="$emit('create-action', $event)"
		@on-local-search="$emit('on-search', $event)"
		@row-on-click="$emit('on-click', $event)"
		@detail-seat="$emit('detail-seat', $event)"
	>
		<template slot="rows" slot-scope="props">
			<td
				v-show="showRow(columns, 1)"
				class="is-not-selectable account">
				<template v-if="editDetailInline && props.row.onEdit && props.row.flagEdit === 1">
					<v-autocomplete
						:items="accounts"
						item-text="fullName"
						item-value="id"
						solo
						hide-details
						class="filter-select shadow-inset select-autocomplete-create edit-inline"
						:value="props.row.accountingAccount"
						return-object
						@input="$emit('get-data', { model: 'accountingAccount', value: $event, row: props.row, index: props.index })">
					</v-autocomplete>
				</template>
				<template v-else>
					<div class="text-account text-absolute">
						<span>{{props.row.accountingAccount.account }}</span>
					</div>
				</template>
			</td>
			<td v-show="showRow(columns, 2)" class="no-movil">
				{{ props.row.accountingAccount.name }}
			</td>
			<td v-show="showRow(columns, 3)">
				<template v-if="editDetailInline && props.row.onEdit && props.row.flagEdit === 1">
					<app-input-text
						class="edit-inline"
						model="reference"
						tabindex="2"
						:text="props.row.reference"
						@input="$emit('get-data', { row: props.row, model: $event.model, value: $event.value, index: props.index })"
					></app-input-text>
				</template>
				<template v-else-if="flagEditInline ">
					<app-input-text
						class="edit-inline"
						model="reference"
						tabindex="2"
						:text="props.row.reference"
						@input="$emit('get-data', { row: props.row, model: $event.model, value: $event.value, index: props.index })"
					></app-input-text>
				</template>
				<template v-else>
					{{ props.row.reference }}
				</template>
			</td>
			<td v-show="showRow(columns, 4)" class="no-movil">
				<template v-if="editDetailInline && props.row.onEdit && props.row.flagEdit === 1">
					<app-input-text
						class="edit-inline"
						model="concept"
						placeholder="Concepto"
						tabindex="3"
						:text="props.row.concept"
						@input="$emit('get-data', { row: props.row, model: $event.model, value: $event.value, index: props.index })"
					></app-input-text>
				</template>
				<template v-else-if="flagEditInline">
					<app-input-text
						class="edit-inline"
						model="concept"
						placeholder="Concepto"
						tabindex="3"
						:text="props.row.concept"
						@input="$emit('get-data', { row: props.row, model: $event.model, value: $event.value, index: props.index })"
					></app-input-text>
				</template>
				<template v-else>
					{{ props.row.concept }}
				</template>
			</td>
			<td v-show="showRow(columns, 5)">{{ getType(props.row) }}</td>
			<td v-show="showRow(columns, 6)" class="amount">
				<template v-if="editDetailInline && props.row.onEdit && props.row.flagEdit === 1">
					<app-input-text
						class="edit-inline"
						model="amount"
						placeholder="Monto"
						tabindex="3"
						:text="props.row.amount"
						@input="$emit('get-data', { row: props.row, model: $event.model, value: $event.value, index: props.index })"
					></app-input-text>
				</template>
				<template v-else>
					<div class="text-amout text-absolute">
						<span :class="[props.row.amount > 0 ?
							'number-positive' : 'number-negative']"
						>
							{{ props.row.amount | formatAmount }}
						</span>
					</div>
				</template>
			</td>
			<td class="gloss" v-show="showRow(columns, 7)">
				<template v-if="editDetailInline && props.row.onEdit">
					<autocomplete-component
						append-icon="expand_more"
						class="edit-inline"
						http-code="$http"
						:item="props.row.costCenter"
						item-text="name"
						item-value="id"
						:show-clear="true"
						:items="costCenters"
						model="costCenterId"
						placeholder-value="Centro de costos"
						prop="name"
						prop-search="name"
						:resource-url="`cost-center/${subsidiaryId}/subsidiary`"
						return-object
						select-create
						tabindex="5"
						@return-data="$emit('get-data', { model: 'costCenter', value: $event, row: props.row, index: props.index })"
					></autocomplete-component>
					<span v-if="validCostCenter(props.row)" class="msg-error">Seleccione centro de costo</span>
				</template>
				<template v-else>
					<p class="mb-0">
						<span class="desktop">Centro de Costo: </span>
						{{ props.row.costCenter ? props.row.costCenter.name : null }}
					</p>
				</template>
			</td>
			<td  v-if="showRow(columns, 8)"  @click.stop="stopClick">
				<template>
					<app-tooltip-button
						:disabled="flagEditInline"
						class="no-movil"
						color="success"
						img="/static/img/actions-list/edit.svg"
						text="Editar (ctrl + alt + E)"
						:width="12"
						@click-icon="$emit('click-icon', { action: 'new-detail-seat', row: props.row, index: props.index })"
					/>
					<app-tooltip-button
						:disabled="props.row.flagEdit === 0"
						class="no-movil"
						color="error"
						img="/static/img/actions-list/delete.svg"
						:text="props.row.flagEdit === 0 ? 'Inhabilitado' :'Eliminar'"
						:width="12"
						@click-icon="$emit('click-icon', { action: 'delete', row: props.row, index: props.index })"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content">
										<app-tooltip-button
											:disabled="flagEditInline"
											color="success"
											img="/static/img/actions-list/edit.svg"
											text="Editar"
											:width="16"
											@click-icon="$emit('click-icon', { action: 'new-detail-seat', row: props.row, index: props.index })"
										/>
										<span class="ml-1 color-primary">Editar</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content">
										<app-tooltip-button
											:disabled="props.row.flagEdit === 0"
											color="error"
											img="/static/img/actions-list/delete.svg"
											:text="props.row.flagEdit === 0 ? 'Inhabilitado' : 'Eliminar'"
											:width="16"
											@click-icon="$emit('click-icon', { action: 'delete', row: props.row, index: props.index })"
										/>
										<span class="ml-1 color-red">Eliminar</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</template>
			</td>
		</template>
		<span
			v-if="codeJournal"
			slot="text"
			class="wrapper-text"
		>
			<v-tooltip top>
					<!-- :disabled="flagDisabledAddSeat || toDeclare" -->
				<v-btn
					slot="activator"
					color="#33cfc7"
					class="btn-auto pa-0 ma-0 btn-add no-movil border-radius"
					type="button"
					@click="$emit('add-detail')"
					>
					<v-icon color="white" size="19">add</v-icon>
				</v-btn>
				<span>Nuevo Detalle (ctrl + alt + k)</span>
			</v-tooltip>
		</span>
	</app-table>
</div>
</template>

<script>
import appInputText from '@/components/autocomplete/app-input-text';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import autocompleteComponent from '@/components/autocomplete/autocomplete-component';

function addIcon() {
	this.$emit('add-icon');
}


function getType({ amount }) {
	return amount < 0 ? 'H' : 'D';
}

function isMobile() {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	return reg.test(navigator.userAgent);
}

function validCostCenter(row) {
	const account = ['4', '5', '6', '7', '8'].includes(row.account ? row.account.charAt(0) :
		row.accountingAccount.code.charAt(0));
	return this.settings.autoCenterCost && account && row.costCenterId === null;
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Cód. Cta', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Cta. Contable', checked: true, visible: true },
			{ id: 3, name: 'Referencia', checked: true, visible: true, movil: true },
			{ id: 4, name: 'Concepto de Movimiento', checked: true, visible: true },
			{ id: 5, name: 'Tipo', checked: true, visible: true, movil: true },
			{ id: 6, name: 'Importe', checked: true, visible: true, movil: true },
			{ id: 7, name: 'Centro de Costo', checked: true, visible: true },
			{ id: 8, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		nameTooltip: 'Nuevo Detalle de Asiento',
	};
}

export default {
	name: 'journal-detail-list',
	components: {
		appInputText,
		appTooltipButton,
		autocompleteComponent,
	},
	computed: {
		isMobile,
	},
	data,
	methods: {
		addIcon,
		getType,
		validCostCenter,
	},
	props: {
		accounts: {
			default: () => [],
			type: Array,
		},
		codeJournal: String,
		costCenters: {
			default: () => [],
			type: Array,
		},
		editDetailInline: {
			default: false,
			type: Boolean,
		},
		rows: {
			type: Array,
			required: true,
		},
		subsidiaryId: [Number, String],
		createdAdd: {
			type: Boolean,
			default: true,
		},
		flagEditInline: {
			default: false,
			type: Boolean,
		},
		flagDisabledAddSeat: {
			default: false,
			type: Boolean,
		},
		toDeclare: {
			default: false,
			type: Boolean,
		},
		settings: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
.relative {
	position: relative;
}

.collapse-menu {
	display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4/5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
			align-items: center;
			display: flex;
			height: 100%;
			justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}

.column-1 {
	@media (max-width: 768px) {
		background-color: #33cfc71a;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}

.color-primary {
	color: #33cfc7;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.color-red {
	color: #ff0000;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 11px;
}

.text-bold {
	font-size: 14px;
	font-weight: 900;
}

.wrapper-text {
	left: 57px;
	position: absolute;
	top: 10px;
}

.text-account {
	background: rgba(51,207,199,0.12);
}

.text-amout {
	background: rgba(0,110,219,0.12);
}

.text-absolute {
    align-items: center;
    display: flex;
	height: 100%;
    justify-content: center;
}
.listjournal {
	border-radius: 10px;
	border: white 5px solid !important;
}
.number-positive {
	color: map-get($colors, secondary);
}

.number-negative {
	color: map-get($colors, error);
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/6;
		grid-row: 2;
		white-space: nowrap;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.btn-edit-detail {
	background-color: color(secondary);
	border-radius: 10px;
	color: color(white);
	font-family: font(AvenirBold);
	font-size: size(small11);
	padding: 2px 4px 0px;
}

.border-radius {
	border-radius: 50%;
	height: 23px;
	width: 23px;
}
.journal-detail-list {
	overflow-y: auto;
	height: calc(60vh - 150px);
}
</style>



// WEBPACK FOOTER //
// src/components/journal/journal-detail-list.vue